module.exports = __webpack_public_path__ + "img/11_12.48ee9713.png";